import { z } from "zod";

// Keep this list aligned with FREE_EMAIL_DOMAINS in backend/server.py.
const FREE_EMAIL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.co.in",
  "yahoo.in",
  "hotmail.com",
  "outlook.com",
  "live.com",
  "icloud.com",
  "me.com",
  "aol.com",
  "proton.me",
  "protonmail.com",
  "gmx.com",
  "mail.com",
  "yandex.com",
  "rediffmail.com",
]);

export function businessEmailError(value) {
  const email = String(value || "").trim().toLowerCase();
  if (!email) return "Enter a business email.";
  if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email)) return "Enter a valid business email.";
  const domain = email.split("@")[1];
  if (FREE_EMAIL_DOMAINS.has(domain)) return "Use your work email address.";
  return "";
}

export function phoneError(value) {
  const text = String(value || "").trim();
  if (!text) return "Enter a phone number.";
  if (!/^[+().\-\s\d]+$/.test(text)) return "Enter a valid phone number.";
  const digits = text.replace(/\D/g, "");
  if (digits.length < 10 || digits.length > 15) {
    return "Enter a valid phone number, including the country code.";
  }
  return "";
}

export const businessEmailSchema = z.string().refine((value) => !businessEmailError(value), (value) => ({
  message: businessEmailError(value),
}));

export const phoneSchema = z.string().refine((value) => !phoneError(value), (value) => ({
  message: phoneError(value),
}));

export const captchaConfigured = Boolean(process.env.REACT_APP_TURNSTILE_SITE_KEY);

export const captchaSchema = captchaConfigured
  ? z.string().min(1, "Complete the security check.")
  : z.string().optional();
